import { ref } from 'vue'
import { HOST_MAP } from './config'

// APITable指令集
const CMD_LIST = {
  // 登录失效
  logout: ({ vm: { $store } }) => {
    $store.dispatch('FedLogOut').then(() => location.reload())
  },
  // 找不到页面
  notfound: ({ vm: { $router } }) => {
    $router.push('/404')
  },
  // 加载完毕
  loaded: ({ loading }) => {
    loading.value = false
  },
  // 提交成功
  submitSuccess: ({ vm, params: path }) => {
    const { $refreshBack, $router } = vm
    $refreshBack.call(vm, true)
    $router.push({ path })
  },
  // 点击取消
  cancel: ({ vm, params }) => {
    vm.$emit('message', {
      cmd: 'cancel',
      params,
    })
  },
}

export const useCmd = (vm) => {
  const loading = ref(true)
  window.addEventListener('message', (e) => {
    if (e.origin !== HOST_MAP[location.host]) return
    const { cmd, source, params } = e.data || {}
    if (source === 'APITABLE2CHE') {
      CMD_LIST[cmd]({ vm, loading, params })
    }
  }, false)

  return { loading }
}
